export default __webpack_public_path__ + "static/media/3_Intro.dcb9d471.mp4";